import React from 'react';
import styled from 'styled-components';


const Wrapper = styled.div`
	position: relative;
	flex-grow: ${props => props.flexGrow};
	flex-shrink: ${props => props.flexShrink};
	padding: ${props => props.padding ?? '0px'};
	overflow: ${props => props.overflow ? props.overflow : (props.flexGrow ? 'hidden' : null)};
	text-align: ${props => props.textAlign};
	min-height: ${props => props.minHeight};
	width: ${props => props.width};
	margin: ${props => props.margin};
	margin-bottom: ${props => props.marginBottom};
`;


export default class FlexBoxBlock extends React.Component {
	render() {
		if (this.props.hidden) {
			return null;
		}
		return (
			<Wrapper className="ps-flexBoxBlock" {...this.props}>
				{this.props.children}
			</Wrapper>
		);
	}
}